import React from 'react';

const ManageAllOrder = () => {
    
    return (
        <div>
            <h2 className='text-2xl text-center font-bold text-primary'>Manage All Order</h2>
            
        </div>
    );
};

export default ManageAllOrder;